// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DomEl$GameDataCore from "../DomEl.res.mjs";

function computeSplitOffset(startOffset, endOffset, textLen, rangeTextLen) {
  var match = endOffset < 0 && startOffset >= 0 ? [
      startOffset,
      Math.min(startOffset + rangeTextLen | 0, textLen)
    ] : (
      startOffset < 0 && endOffset >= 0 ? [
          Math.max(0, endOffset - rangeTextLen | 0),
          endOffset
        ] : [
          startOffset,
          endOffset
        ]
    );
  var resolvedStart = match[0];
  if (resolvedStart > 0 && resolvedStart < textLen) {
    return resolvedStart;
  }
  var resolvedEnd = match[1];
  if (resolvedEnd > 0 && resolvedEnd < textLen) {
    return resolvedEnd;
  } else {
    return -1;
  }
}

function shouldAllowKey(key, metaKey) {
  var safeMeta = metaKey && (key === "r" || key === "t" || key === "n" || key === "o" || key === "l" || key === "w" || key === "p" || key === "c");
  var arrowOrTab = key === "ArrowUp" || key === "ArrowDown" || key === "ArrowLeft" || key === "ArrowRight" || key === "Tab";
  if (safeMeta) {
    return true;
  } else {
    return arrowOrTab;
  }
}

function computeButtonTop(rectTop, viewportHeight, paddingOpt, btnHeightOpt) {
  var padding = paddingOpt !== undefined ? paddingOpt : 8;
  var btnHeight = btnHeightOpt !== undefined ? btnHeightOpt : 28;
  var initial = rectTop - padding;
  var clampedLow = initial < padding ? padding : initial;
  if (clampedLow + btnHeight > viewportHeight - padding) {
    return viewportHeight - btnHeight - padding;
  } else {
    return clampedLow;
  }
}

function getSelectionStartOffset(container, range) {
  if (!container.contains(range.startContainer)) {
    return -1;
  }
  try {
    var r = document.createRange();
    r.selectNodeContents(container);
    r.setEnd(range.startContainer, range.startOffset);
    return r.toString().length;
  }
  catch (exn){
    return -1;
  }
}

function getSelectionEndOffset(container, range) {
  if (!container.contains(range.endContainer)) {
    return -1;
  }
  try {
    var r = document.createRange();
    r.selectNodeContents(container);
    r.setEnd(range.endContainer, range.endOffset);
    return r.toString().length;
  }
  catch (exn){
    return -1;
  }
}

function isSelectionInside(container, selection) {
  if (selection.rangeCount === 0 || !container.isConnected) {
    return false;
  }
  var range = selection.getRangeAt(0);
  if (range.intersectsNode(container)) {
    return true;
  } else {
    return container.contains(range.commonAncestorContainer);
  }
}

function mounted() {
  var self = this ;
  var root = self.el;
  var match = root.querySelector("[id^=\"snippet-split-content-\"]");
  var match$1 = root.querySelector("[id^=\"snippet-split-button-\"]");
  if (match == null) {
    return ;
  }
  if (match$1 == null) {
    return ;
  }
  self.container = match;
  self.splitButton = match$1;
  match.textContent = DomEl$GameDataCore.data(match, "text");
  var hideButton = function () {
    var splitButton = self.splitButton;
    DomEl$GameDataCore.addClass(splitButton, "hidden");
    splitButton.style.position = "";
    splitButton.style.top = "";
    splitButton.style.left = "";
  };
  var handleSelectionChange = function (_event) {
    var selection = globalThis.getSelection();
    if (selection == null) {
      return hideButton();
    }
    var container = self.container;
    if (!isSelectionInside(container, selection) || selection.isCollapsed) {
      return hideButton();
    }
    var range = selection.getRangeAt(0);
    var startOffset = getSelectionStartOffset(container, range);
    var endOffset = getSelectionEndOffset(container, range);
    var text = DomEl$GameDataCore.text(container);
    var len = text.length;
    var rangeTextLen = range.toString().length;
    var splitAt = computeSplitOffset(startOffset, endOffset, len, rangeTextLen);
    if (splitAt <= 0 || splitAt >= len) {
      return hideButton();
    } else {
      var splitButton = self.splitButton;
      var _snippetIndex = root.getAttribute("data-snippet-index");
      if (_snippetIndex == null) {
        return ;
      }
      splitButton.setAttribute("data-split-offset", String(splitAt));
      var rect = range.getBoundingClientRect();
      var top = computeButtonTop(rect.top, window.innerHeight, undefined, undefined);
      splitButton.style.position = "fixed";
      splitButton.style.top = String(top) + "px";
      splitButton.style.left = String(rect.left + rect.width / 2.0) + "px";
      return DomEl$GameDataCore.removeClass(splitButton, "hidden");
    }
  };
  var handleSelectionChangeDeferred = function (_event) {
    handleSelectionChange(_event);
    setTimeout((function () {
            handleSelectionChange(_event);
          }), 0);
    setTimeout((function () {
            handleSelectionChange(_event);
          }), 50);
  };
  var handleSplitClick = function () {
    var splitButton = self.splitButton;
    var match = splitButton.getAttribute("data-split-offset");
    var match$1 = root.getAttribute("data-snippet-index");
    var match$2 = root.getAttribute("data-target-id");
    if (match == null) {
      return ;
    }
    if (match$1 == null) {
      return ;
    }
    if (match$2 == null) {
      return ;
    }
    self.pushEventTo("#" + match$2, "split_snippet", {
          "snippet-index": match$1,
          "split-offset": match
        });
    var selection = globalThis.getSelection();
    if (!(selection == null)) {
      selection.removeAllRanges();
    }
    hideButton();
  };
  var preventDefault = function ($$event) {
    $$event.preventDefault();
  };
  var preventDefaultAllowSafeKeys = function ($$event) {
    if (!shouldAllowKey($$event.key, $$event.metaKey)) {
      $$event.preventDefault();
      return ;
    }
    
  };
  var onSplitButtonClick = function ($$event) {
    $$event.preventDefault();
    $$event.stopPropagation();
    handleSplitClick();
  };
  var passiveFalse = {
    passive: false
  };
  var addListeners = function () {
    var container = self.container;
    var splitButton = self.splitButton;
    container.addEventListener("input", preventDefault, passiveFalse);
    container.addEventListener("focusout", preventDefault, passiveFalse);
    container.addEventListener("cut", preventDefault, passiveFalse);
    container.addEventListener("paste", preventDefault, passiveFalse);
    container.addEventListener("dragstart", preventDefault, passiveFalse);
    container.addEventListener("dragover", preventDefault, passiveFalse);
    container.addEventListener("dragend", preventDefault, passiveFalse);
    container.addEventListener("keydown", preventDefaultAllowSafeKeys, passiveFalse);
    container.addEventListener("keypress", preventDefaultAllowSafeKeys, passiveFalse);
    document.addEventListener("selectionchange", handleSelectionChange, passiveFalse);
    window.addEventListener("mouseup", handleSelectionChangeDeferred, passiveFalse);
    window.addEventListener("touchend", handleSelectionChangeDeferred, passiveFalse);
    splitButton.addEventListener("click", onSplitButtonClick);
  };
  var removeListeners = function () {
    var container = self.container;
    var splitButton = self.splitButton;
    container.removeEventListener("input", preventDefault);
    container.removeEventListener("focusout", preventDefault);
    container.removeEventListener("cut", preventDefault);
    container.removeEventListener("paste", preventDefault);
    container.removeEventListener("dragstart", preventDefault);
    container.removeEventListener("dragover", preventDefault);
    container.removeEventListener("dragend", preventDefault);
    container.removeEventListener("keydown", preventDefaultAllowSafeKeys);
    container.removeEventListener("keypress", preventDefaultAllowSafeKeys);
    document.removeEventListener("selectionchange", handleSelectionChange);
    window.removeEventListener("mouseup", handleSelectionChangeDeferred);
    window.removeEventListener("touchend", handleSelectionChangeDeferred);
    splitButton.removeEventListener("click", onSplitButtonClick);
  };
  self._snippetSplitHandlers = {
    preventDefault: preventDefault,
    preventDefaultAllowSafeKeys: preventDefaultAllowSafeKeys,
    handleSelectionChange: handleSelectionChange,
    handleSelectionChangeDeferred: handleSelectionChangeDeferred,
    onSplitButtonClick: onSplitButtonClick,
    hideButton: hideButton,
    removeListeners: removeListeners
  };
  addListeners();
}

function destroyed() {
  var self = this ;
  var handlers = self._snippetSplitHandlers;
  if (!(handlers == null)) {
    handlers.removeListeners();
    return handlers.hideButton();
  }
  
}

var snippetSplit = {
  mounted: mounted,
  destroyed: destroyed
};

export {
  computeSplitOffset ,
  shouldAllowKey ,
  computeButtonTop ,
  getSelectionStartOffset ,
  getSelectionEndOffset ,
  isSelectionInside ,
  mounted ,
  destroyed ,
  snippetSplit ,
}
/* mounted Not a pure module */
